import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.scss";
import { useTranslation } from "react-i18next";
import "./InspirasiTerkini.scss";

import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper";
import { LatestInspirarationAPI } from "@api";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

const InspirasiTerkini = () => {
  const { t } = useTranslation();
  const [controller, setController] = useState(null);
  const [latestInpirationData, setLatestInpirationData] = useState(null);

  useEffect(() => {
    const loadLatestInpirationData = async () => {
      const { data } = await LatestInspirarationAPI();      
      setLatestInpirationData(data.data.item);
    };
  
    if (latestInpirationData === null) {
      loadLatestInpirationData();
    }
  }, [latestInpirationData])

  const onNext = () => {
    controller.slideNext();
  };
  return (
    <div className="inspirasi-terkini">
      <h4>{t("current_inspiration")}</h4>
      <div className="body">
        <Swiper
          spaceBetween={24}
          slidesPerView={'auto'}
          loop={false}
          scrollbar={{
            draggable: true,
          }}
          onSwiper={(swiper) => setController(swiper)}
        >
          {latestInpirationData?.map((data, i) => (
            <SwiperSlide key={i} className="card-slide">
              <a href={`/inspiration/artikel/${data.slug}`}>
                <img src={data.imageDesktop} alt="..." />                
                <div className="body">
                  <h5>{data.judul}</h5>
                </div>
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="card-slide-navigation">
          <button onClick={() => onNext()}>
            <i className="bi bi-chevron-right"></i>
          </button>
        </div>
      </div>
      <div className="footer">
        <a href="/inspiration" className="btn btn-outline-warning">{t("more")}</a>
      </div>
    </div>
  );
};

export default InspirasiTerkini;
